import React from "react";
import { observer } from "mobx-react";
import { TenantPlanViewStore } from "../../store";
import { TenantPlanViewForm } from "./TenantPlanViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type TenantPlanViewProps = {
  tenantPlanViewStore: TenantPlanViewStore;
};

export const TenantPlanView: React.FC<TenantPlanViewProps> = observer(
  ({ tenantPlanViewStore }) => {
    return (
      <div>
        <TenantPlanViewForm
          name_es={tenantPlanViewStore.name_esValue}
          name_en={tenantPlanViewStore.name_enValue}
          name_pt={tenantPlanViewStore.name_ptValue}
          description_es={tenantPlanViewStore.description_esValue}
          description_en={tenantPlanViewStore.description_enValue}
          description_pt={tenantPlanViewStore.description_ptValue}
          limits={tenantPlanViewStore.limitsValue}
          onPrint={(handlePrint: () => void) =>
            tenantPlanViewStore.printTenantPlan(handlePrint)
          }
          onCancel={() => tenantPlanViewStore.cancelTenantPlan()}
          onEdit={
            tenantPlanViewStore.isEditEnabled
              ? () => tenantPlanViewStore.editTenantPlan()
              : undefined
          }
        />
        <ErrorDialog
          open={tenantPlanViewStore.errorDialogOpened}
          title={tenantPlanViewStore.errorTitle}
          description={tenantPlanViewStore.errorDescription}
          onClose={() => tenantPlanViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
